import { apiClient } from '@shared/utils/api-client';

export type PromotionAudience = 'clients' | 'sellers';
/** Для продавцов: push — пуш и запись в кабинете, email — письмо на email директора */
export type PromotionChannel = 'push' | 'email';

export interface SendPromotionPayload {
    title: string;
    body?: string;
    /** По умолчанию clients */
    audience?: PromotionAudience;
    channel?: PromotionChannel;
    userIds?: number[];
    sellerIds?: number[];
    /** По умолчанию true: только получателям с согласием на рекламную рассылку. */
    isAdvertising?: boolean;
    /** ISO-момент отправки; время формы переводится из московского часового пояса. */
    scheduledAt?: string;
}

export interface SendPromotionResult {
    ok: boolean;
    message: string;
    id?: number;
}

export interface ScheduledPromotion {
    id: number;
    title: string;
    body: string | null;
    audience: 'CLIENTS' | 'SELLERS';
    channel: 'PUSH' | 'EMAIL';
    isAdvertising: boolean;
    recipientIds: number[] | null;
    scheduledAt: string;
    status: 'PENDING' | 'PROCESSING';
    createdAt: string;
}

export interface PromotionHistoryItem {
    id: number;
    title: string;
    body: string | null;
    audience: 'CLIENTS' | 'SELLERS';
    channel: 'PUSH' | 'EMAIL';
    isAdvertising: boolean;
    recipientIds: number[] | null;
    scheduledAt: string;
    status: 'PROCESSING' | 'SENT' | 'FAILED' | 'CANCELED';
    sentAt: string | null;
    sentCount: number | null;
    failedCount: number | null;
    error: string | null;
    createdAt: string;
    createdByAdmin: { id: number; name: string | null; email: string } | null;
}

export const pushApi = {
    getPromotionHistory: async (): Promise<PromotionHistoryItem[]> => {
        return apiClient.get<PromotionHistoryItem[]>('/push-notifications/admin/promotion-history');
    },
    sendPromotion: async (data: SendPromotionPayload): Promise<SendPromotionResult> => {
        return apiClient.post<SendPromotionResult>('/push-notifications/admin/send-promotion', data);
    },
    getScheduledPromotions: async (): Promise<ScheduledPromotion[]> => {
        return apiClient.get<ScheduledPromotion[]>('/push-notifications/admin/scheduled-promotions');
    },
    cancelScheduledPromotion: async (id: number): Promise<{ ok: boolean }> => {
        return apiClient.patch<{ ok: boolean }>(
            `/push-notifications/admin/scheduled-promotions/${id}/cancel`,
            undefined,
        );
    },
};
